import { render, staticRenderFns } from "./Highlight-annotate.vue?vue&type=template&id=c64b0790&scoped=true&"
import script from "./Highlight-annotate.vue?vue&type=script&lang=js&"
export * from "./Highlight-annotate.vue?vue&type=script&lang=js&"
import style0 from "./Highlight-annotate.vue?vue&type=style&index=0&id=c64b0790&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64b0790",
  null
  
)

export default component.exports